import styled from 'styled-components';
import { mediumBreakpoint } from 'utilities/constants';
import { Inner } from 'styles/global.styled';

export const AIBInner = styled(Inner)`
  width: 100%;
  max-width: 70rem;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  text-align: left;
  margin: auto;
  justify-content: space-between;

  @media (max-width: ${mediumBreakpoint}px) {
    max-width: 100%;
    padding: 0;
    padding: 0rem;
  }
`;
